import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { LANGS, tr } from "@/i18n/translations";

const LangCtx = createContext({ lang: "ar", t: (k) => k, setLang: () => {}, showChooser: false, setShowChooser: () => {} });

const STORAGE_KEY = "kh_lang";

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "ar";
    return localStorage.getItem(STORAGE_KEY) || "";
  });
  const [showChooser, setShowChooser] = useState(false);

  // First visit → force chooser once, default to Arabic behind the scenes.
  // EXCEPTION: on the public /download page we skip the chooser so the user
  // scanning a QR goes straight to the store buttons.
  useEffect(() => {
    if (!lang) {
      const path = (typeof window !== "undefined" && window.location.pathname) || "";
      if (path.startsWith("/download")) {
        setLangState("ar");
      } else {
        setShowChooser(true);
        setLangState("ar"); // temporary until user picks
      }
    }
  }, [lang]);

  // Apply <html dir=""> + <html lang="">
  useEffect(() => {
    const info = LANGS[lang] || LANGS.ar;
    document.documentElement.setAttribute("lang", info.code);
    document.documentElement.setAttribute("dir", info.dir);
  }, [lang]);

  const setLang = useCallback((code) => {
    if (!LANGS[code]) return;
    localStorage.setItem(STORAGE_KEY, code);
    setLangState(code);
    setShowChooser(false);
  }, []);

  const t = useCallback((key) => tr(key, lang || "ar"), [lang]);

  return (
    <LangCtx.Provider value={{ lang: lang || "ar", t, setLang, showChooser, setShowChooser }}>
      {children}
    </LangCtx.Provider>
  );
}

export function useLang() {
  return useContext(LangCtx);
}
